"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
exports.UserMenuImage = ({ imageUrl, userName }) => (React.createElement("img", { src: imageUrl, alt: userName, className: "main-nav-avatar-photo" }));



//////////////////
// WEBPACK FOOTER
// ./src/components/UserMenu/UserMenuImage.tsx
// module id = 387
// module chunks = 0